import type { JSX } from 'react';
import { Button } from '../../../_components/Button.js';
import type { Palette } from '../../../_theme/palette.js';

interface StatusViewProps {
  palette: Palette;
  message: string;
  error?: boolean;
  onClose: () => void;
}

export function StatusView({ palette, message, error = false, onClose }: StatusViewProps): JSX.Element {
  return (
    <div style={{ padding: 28, textAlign: 'center' }}>
      <p style={{ color: error ? '#dc2626' : palette.textMuted }}>{message}</p>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
        <Button palette={palette} onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
}
